(function() { module.exports = window["fetch"]; }());